var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');

var MedProfileImportSettingsForm = Marionette.View.extend({
    template: require('../../templates/organizations/medical-profile-import-settings-form.html'),

    regions: {
        stateSelect: '#select-state',
        orgSelectState: '#org-select-state'
    },

    ui: {
        save: '#save',
        cancel: '#cancel',

        ccrDemographics: '#ccr-demographics',
        ccrMedications: '#ccr-medications',
        ccrProblems: '#ccr-medical-problems',
        ccrVisits: '#ccr-visits',

        ccdDemographics: '#ccd-demographics',
        ccdMedications: '#ccd-medications',
        ccdProblems: '#ccd-medical-problems',
        ccdVisits: '#ccd-visits'

    },

    events: {
        'click @ui.save': 'onSave',
        'click @ui.cancel': 'onCancel',

        'click @ui.ccrDemographics': 'onCheckCcrDemographics',
        'click @ui.ccrMedications': 'onCheckCcrMedications',
        'click @ui.ccrProblems': 'onCheckCcrProblems',
        'click @ui.ccrVisits': 'onCheckCcrVisits',

        'click @ui.ccdDemographics': 'onCheckCcdDemographics',
        'click @ui.ccdMedications': 'onCheckCcdMedications',
        'click @ui.ccdProblems': 'onCheckCcdProblems',
        'click @ui.ccdVisits': 'onCheckCcdVisits'
    },

    templateContext: function () {
        var that = this;
        return {
            ccrPermissions: this.ccrPermissions,
            ccdPermissions: this.ccdPermissions
        }
    },


    initialize: function (options) {
        this.utils = new CommonUtils();
        this.ccrPermissions = _.clone(options.ccrPermissions) || this.initMedicalImportPermissions();
        this.ccrPermissionsOriginal = _.clone(options.ccrPermissions);
        this.ccdPermissions = _.clone(options.ccdPermissions) || this.initMedicalImportPermissions();
        this.ccdPermissionsOriginal = _.clone(options.ccdPermissions);
    },

    onRender: function () {
        this.validate();
    },

    initMedicalImportPermissions: function () {
        return {
            demographics: false,
            medications: false,
            medicalProblems: false,
            visits: false
        }
    },

    onSave: function () {
        this.triggerMethod('save:import:settings', {
            ccrPermissions: this.ccrPermissions,
            ccdPermissions: this.ccdPermissions
        });
    },

    onCancel: function () {
        this.triggerMethod('cancel:import:settings');
    },

    validate: function () {
        if (_.isEqual(this.ccrPermissions, this.ccrPermissionsOriginal) && _.isEqual(this.ccdPermissions, this.ccdPermissionsOriginal))
            this.disableButtons();
        else
            this.enableButtons();
    },

    enableButtons: function () {
        this.ui.save.removeAttr('disabled');
        this.ui.cancel.removeAttr('disabled');
    },

    disableButtons: function () {
        this.ui.save.attr('disabled', true);
        this.ui.cancel.attr('disabled', true);
    },

    onCheckCcrDemographics: function(event) {
        this.ccrPermissions.demographics = event.target.checked;
        this.validate();
    },

    onCheckCcrMedications: function(event) {
        this.ccrPermissions.medications = event.target.checked;
        this.validate();
    },

    onCheckCcrProblems: function(event) {
        this.ccrPermissions.medicalProblems = event.target.checked;
        this.validate();
    },

    onCheckCcrVisits: function(event) {
        this.ccrPermissions.visits = event.target.checked;
        this.validate();
    },

    onCheckCcdDemographics: function(event) {
        this.ccdPermissions.demographics = event.target.checked;
        this.validate();
    },

    onCheckCcdMedications: function(event) {
        this.ccdPermissions.medications = event.target.checked;
        this.validate();
    },

    onCheckCcdProblems: function(event) {
        this.ccdPermissions.medicalProblems = event.target.checked;
        this.validate();
    },

    onCheckCcdVisits: function(event) {
        this.ccdPermissions.visits = event.target.checked;
        this.validate();
    }

});

module.exports = MedProfileImportSettingsForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/organizations/medical-profile-import-settings-form.js
// module id = 272
// module chunks = 0